/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const LanguagesIcon = ({ className }) => (
  <svg
    className={className}
    width="25px"
    height="23px"
    viewBox="0 0 400 400"
    version="1.2"
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      fill="currentColor"
      d="M194.1 227.8c-28.9-12.1-52.1-28.1-70.4-44.1 10.1-12.3 17.9-24.3 24-35.1 14.2-25.1 21.1-47.3 24.3-60.4h27.3v-38h-82.2V27.5H82.2v22.7H0v38h135.5c-3.3 10.8-9 25.7-18.5 42.1-5.6 9.7-11.9 18.9-18.9 27.6-13.6-15.7-21.9-29.3-25.8-36.1l-29.8 19.9c6.2 11 16 26.1 30.4 42.7-19.9 17.7-43.4 32.2-70.4 43.5L15 263.3c35-14.6 62.3-33.4 83.4-52.9 24.8 22.5 52.7 40.3 82.9 52.9l12.8-35.5zm60.8 42.6l26.5-67.3 26.5 67.3h-53zm46.6-134h-40.4l-96.8 236.1h50.3l22.8-58H325l22.8 58h52l-98.3-236.1z"
    />
  </svg>
);

export default LanguagesIcon;
